import {ScenarioStepParameter} from './ScenarioStepParameter';

export class ScenarioParameters {
color: string;
main: boolean | null;
owner: string;
shared: boolean | null;
stepParameters: ScenarioStepParameter[];
userMode: boolean | null;
}

